

var ListView = xClass("ListView", ccui.ScrollView)

ListView.prototype.ctor = function (length, contentSize, innerSize) {
    var self = this;
    ccui.ScrollView.prototype.ctor.call(self);
    self.setContentSize(contentSize);
    self.setClippingEnabled(true);
    self.setBounceEnabled(false);
    self.setInnerContainerSize(innerSize);
    self.items = new Array();
    self.totalLength = length;
    self.innerSize = innerSize;
    self.itemOffset = ccp(0, 0);

    
    self._handleMoveLogic = function(touch) {
        var touchPositionInNodeSpace = self.convertToNodeSpace(touch.getLocation())
          , previousTouchPositionInNodeSpace = self.convertToNodeSpace(touch.getPreviousLocation());
        var delta = cc.pSub(touchPositionInNodeSpace, previousTouchPositionInNodeSpace);
        delta.y = delta.y/2;
        self._scrollChildren(delta);
        self._gatherTouchMove(delta);
    },

    self.init();
}

ListView.prototype.init = function () {
    var self = this
    self.scrollInnerPosY = self._innerContainer.y;
    self.scrollviewMoveDir = 0; //往上1往下2
    self.addEventListener(function (view, event) {
        if (event == ccui.ScrollView.EVENT_CONTAINER_MOVED){
            if (self._innerContainer.y < self.scrollInnerPosY){
                self.scrollviewMoveDir = 1;
            }
            if (self._innerContainer.y > self.scrollInnerPosY){
                self.scrollviewMoveDir = 2;
            }
            self.scrollInnerPosY = self._innerContainer.y;
        }
    });
}

ListView.prototype.setItemOffset = function(x, y){
    var self = this;
    self.itemOffset = cc.p(x, y);
}

ListView.prototype.addItem = function(item, idx, z, tag) {
    var self = this;
    ccui.ScrollView.prototype.addChild.call(this, item, z, tag);
    var itemSize = item.getContentSize();
    item.setPosition(self.itemOffset.x, self.innerSize.height-idx*(itemSize.height+self.itemOffset.y));
    // cc.log(self.itemOffset.x, self.innerSize.height-idx*(itemSize.height+self.itemOffset.y));
    self.items.push(item);
    item.idx = idx;
}

ListView.prototype.getItems = function() {
    var self = this;
    return self.items;
}

ListView.prototype.update = function(dt) {
    // cc.log("update");
    var self = this;
    ccui.ScrollView.prototype.update.call(this, dt);
    self.refreshItems();
}

ListView.prototype.setRefreshItemContentFunc = function(func){
    var self = this;
    self.refreshItemContent = func;
}

ListView.prototype.refreshItems = function(){
    var self = this;
    // cc.log(self.scrollviewMoveDir)
    if (self.scrollviewMoveDir == 0){
        return
    }
    if (!self.scrollViewWorldRect){
        var pos = self.getParent().convertToWorldSpace(self.getPosition());
        var anchor = self.getAnchorPoint();
        var size = self.getContentSize();
        self.scrollViewWorldRect = cc.rect(pos.x - anchor.x * size.width, pos.y - anchor.y * size.height, size.width, size.height);
    }

    var getItemRect = function(idx){
        var item = self.items[idx];
        var pos = item.getParent().convertToWorldSpace(item.getPosition());
        var size = item.getContentSize();
        var anchor = item.getAnchorPoint();
        var rect = cc.rect(pos.x - anchor.x * size.width, pos.y - anchor.y * size.height - size.height, size.width, size.height);
        return rect;
    }

    var length = self.items.length;
    var itemRect0 = getItemRect(0);
    var itemRectLast = getItemRect(length-1);
    // cc.log(itemRectLast.y , self.scrollViewWorldRect.y);
    if (((self.scrollviewMoveDir == 2 && itemRect0.y > self.scrollViewWorldRect.y) || ( self.scrollviewMoveDir == 1 && itemRectLast.y > self.scrollViewWorldRect.y)) && !cc.rectIntersectsRect(self.scrollViewWorldRect, itemRect0)){
        // cc.log("idx 0 out of scrollview");
        var item = self.items[0];
        var lastItem = self.items[length-1];
        if (lastItem.idx < self.totalLength){
            item.idx = lastItem.idx + 1;
            var itemSize = item.getContentSize();
            item.setPosition(cc.pSub(lastItem.getPosition(), cc.p(0, itemSize.height + self.itemOffset.y)));
            self.items.splice(0, 1);
            self.items.push(item);
            if (self.refreshItemContent){
                self.refreshItemContent(item);
            }
        }else{
            // cc.log("!!!!!!!", lastItem.idx)
        }
        return;
    }
    // cc.log(cc.rectIntersectsRect(self.scrollViewWorldRect, itemRectLast));
    if (((self.scrollviewMoveDir == 1 && itemRectLast.y < self.scrollViewWorldRect.y + self.scrollViewWorldRect.height) || (self.scrollviewMoveDir == 2 && itemRect0.y < self.scrollViewWorldRect.y)) && !cc.rectIntersectsRect(self.scrollViewWorldRect, itemRectLast)){
        // cc.log("idx last out of scrollview");
        var item = self.items[length-1];
        var firstItem = self.items[0];
        if (firstItem.idx >= 0){
            item.idx = firstItem.idx - 1;
            var itemSize = item.getContentSize();
            item.setPosition(cc.pAdd(firstItem.getPosition(), cc.p(0, itemSize.height + self.itemOffset.y)));
            self.items.splice(length-1, 1);
            self.items.unshift(item);
            if (self.refreshItemContent){
                self.refreshItemContent(item);
            }
        }else{
            // cc.log("!!!!!!!", firstItem.idx)
        }
        return;
    }
}

ListView.prototype.changeData = function(totalLength, innerSize) {
    let self = this;

    self.stopAutoScroll();
    self.setInnerContainerSize(innerSize);
    self.innerSize = innerSize;
    self.totalLength = totalLength;

    self.scrollviewMoveDir = 0;

    self.scrollViewWorldRect = null;
    self.scrollInnerPosY = self._innerContainer.y;
    
    for(let i = 0, item = self.items[0]; i < self.items.length; i++, item = self.items[i]) {
        item.idx = i;
        let itemSize = item.getContentSize();
        item.setPosition(self.itemOffset.x, self.innerSize.height-item.idx*(itemSize.height+self.itemOffset.y));
        self.refreshItemContent && self.refreshItemContent.call(null, item);
    }
}

module.exports = ListView
